
import { Component, Emit, Prop, Ref, Vue, Watch } from 'vue-property-decorator';

// SVG
import CrossSVG from '@/assets/cross.svg';

// Components
import VButtonIcon from '@/components/VButton/VButtonIcon.vue';
import VueMultiselect from '@/plugins/VueMultiselect';

// Utils
import { addHorizontalScroll } from '@/utils/Helper';
import { isEmpty, isEqual } from 'lodash';

@Component({
    inheritAttrs: false,
    components: {
        CrossSVG,
        VButtonIcon,
        VueMultiselect,
    },
})
export default class VSelect extends Vue {
    @Ref() public multiselect!: VueMultiselect;

    @Prop({ type: String, default: '' })
    public placeholder!: string;

    @Prop({ default: '' })
    public value!: unknown;

    @Prop({ type: Function, default: (value: unknown) => value })
    public reduce!: (value: unknown) => unknown;

    @Prop({ type: Array, default: () => [] })
    public options!: unknown[];

    @Prop({ type: Boolean, default: false })
    public disableClear!: boolean;

    @Prop({ type: Boolean, default: false })
    public multiple!: boolean;

    @Prop({ type: Boolean, default: false })
    public error!: boolean;

    @Prop({ type: String, default: '' })
    public subLabel!: string;

    @Prop({ type: Boolean, default: true })
    public closeOnSelect!: boolean;

    public selected: unknown = null;

    get isSelected() {
        return !isEmpty(this.selected);
    }

    get isClearable() {
        return this.isSelected && !this.disableClear && !this.$attrs.disabled;
    }

    public clearSelected() {
        this.selected = this.multiple && Array.isArray(this.value) ? [] : null;
        this.$emit('input', this.selected);
        this.$emit('cleared');
    }

    public getOptionByValue(value: unknown) {
        const predicate = (x: unknown) => this.options.find((option) => isEqual(this.reduce(option), x));

        if (this.multiple && Array.isArray(value)) {
            return value.map(predicate).filter((option) => option !== undefined);
        }
        return predicate(value);
    }

    @Emit('input')
    public inputHandler(value: unknown) {
        if (this.multiple && Array.isArray(value)) {
            return value.map((option) => this.reduce(option));
        }
        return this.reduce(value);
    }

    public getCustomLabel<T = object>(option: T, label: keyof T) {
        if (isEmpty(option)) return '';
        return label ? option[label] : label;
    }

    public created() {
        this.valueWatchHandler();
    }

    public mounted() {
        if (this.multiple) {
            addHorizontalScroll(this.$el.querySelector('.multiselect__tags-wrap')!, this);
        }
    }

    @Watch('value')
    public valueWatchHandler() {
        this.selected = this.getOptionByValue(this.value);
    }
}
